var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmployeeProfile = function SvgEmployeeProfile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 11.997,
    viewBox: "0 0 20 11.997",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_799",
    "data-name": "Group 799",
    transform: "translate(-10426 309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731",
    transform: "translate(10460 -370)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 3.599,
    cy: 3.605,
    rx: 3.599,
    ry: 3.605,
    transform: "translate(-32.515 61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M-34,72.022c1.3,1.3,8.885,1.3,10.189,0v-.066a2.891,2.891,0,0,0-2.881-2.884h-4.427A2.882,2.882,0,0,0-34,71.955h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "id-card-f",
    d: "M1,0H9a.966.966,0,0,1,1,.928V5.571A.966.966,0,0,1,9,6.5H1a.966.966,0,0,1-1-.929V.928A.966.966,0,0,1,1,0ZM5.5,1.5a.5.5,0,0,0,0,1h3a.5.5,0,1,0,0-1ZM5.5,3a.5.5,0,0,0,0,1h3a.5.5,0,1,0,0-1Zm-4-1.5A.5.5,0,0,0,1,2V3.5a.5.5,0,0,0,.5.5H3a.5.5,0,0,0,.5-.5V2A.5.5,0,0,0,3,1.5Z",
    transform: "translate(10436 -309)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmployeeProfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/employee-profile.ebff054c033e3161940bae20cc5a97ea.svg";